module.exports = __webpack_public_path__ + "img/button-tokopedia.ebae5684.png";